import React from 'react'
import { SidebarButton } from 'Components/Sidebar/SidebarButton'
import { isSmallScreen } from 'Utils/Misc'
import { connect } from 'react-redux'
import { closeMainSidebar } from 'Reducers/UI/actions'

const isMobile = isSmallScreen()

const WrappedSidebarButton = ({ closeMainSidebar, ...otherProps }) => (
  <div
    onClick={() => {
      if (isMobile) closeMainSidebar()
    }}
  >
    <SidebarButton {...otherProps} />
  </div>
)

const mapDispatchToProps = {
  closeMainSidebar,
}

export default connect(
  null,
  mapDispatchToProps,
)(WrappedSidebarButton)
